module.exports = __webpack_public_path__ + "media/images/service-icon-01-f09ee2d2f74e9bc1ca4dbd55ec7c7ca5.png";